import React from "react";

export default function TermsPage() {
  // Estilos adaptados para fundo escuro/cinza
  const styles = {
    container: {
      padding: "40px 20px",
      maxWidth: "900px",
      margin: "0 auto",
      lineHeight: "1.6",
      fontFamily: "Arial, sans-serif",
      color: "#ffffff", // Texto branco
      backgroundColor: "#1e1e1e", // Garante o fundo caso o pai não tenha
    },
    h1: {
      fontSize: "24px",
      fontWeight: "bold",
      marginBottom: "20px",
      marginTop: "40px",
      borderBottom: "1px solid rgba(255, 255, 255, 0.2)", // Borda sutil
      paddingBottom: "10px",
    },
    h2: {
      fontSize: "20px",
      fontWeight: "bold",
      marginTop: "30px",
      marginBottom: "15px",
    },
    h3: {
      fontSize: "18px",
      fontWeight: "bold",
      marginTop: "25px",
      marginBottom: "10px",
    },
    p: {
      marginBottom: "15px",
      textAlign: "justify",
    },
    ul: {
      marginBottom: "20px",
      paddingLeft: "20px",
    },
    li: {
      marginBottom: "8px", // Leve aumento para melhor leitura
    },
    divider: {
      margin: "40px 0",
      border: "0",
      borderTop: "1px solid rgba(255, 255, 255, 0.2)", // Divisória sutil
    },
    alertBox: {
      backgroundColor: "rgba(255, 255, 255, 0.1)", // Fundo translúcido
      borderLeft: "5px solid #d9534f", // Mantém a cor de alerta vermelha
      padding: "15px",
      marginBottom: "20px",
      borderRadius: "4px",
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={{ ...styles.h1, marginTop: 0 }}>
        Política de Reembolso, Cancelamento e Regras de Execução do Bot
      </h1>

      <h2 style={styles.h2}>1. Direito de Arrependimento (7 dias)</h2>
      <p style={styles.p}>
        Conforme o art. 49 do Código de Defesa do Consumidor (CDC), o usuário
        poderá solicitar reembolso integral somente dentro de 7 dias corridos a
        partir da data da contratação ou renovação da assinatura, desde que o
        serviço tenha sido adquirido pela internet. Após esse prazo, o reembolso
        não será obrigatório, salvo nos casos previstos neste documento.
      </p>

      <h2 style={styles.h2}>2. Cancelamento Após os 7 Dias</h2>
      <p style={styles.p}>
        Após o período legal de 7 dias, o usuário poderá solicitar o cancelamento
        da assinatura, que será efetivado para o ciclo seguinte, com interrupção
        das cobranças futuras. Valores já pagos não serão reembolsados, exceto
        conforme regras específicas do item 4. 
      </p>
      <div style={styles.alertBox}>
        <strong>Nota:</strong> O reembolso só pode ser solicitado uma única vez por CPF/usuário. 
        Ao recontratar o bot após um pedido de reembolso anterior, o usuário reconhece expressamente 
        que renuncia ao direito de novo arrependimento.
      </div>

      <hr style={styles.divider} />

      <h1 style={styles.h1}>
        3. Regras Gerais de Funcionamento e Execução das Ordens
      </h1>
      <p style={styles.p}>
        O bot atua como ferramenta de automação que executa ordens com base em
        sinais recebidos por terceiros (grupos de Telegram, traders, provedores
        externos). O bot não gera sinais próprios e não assegura resultados
        financeiros.
      </p>

      <p style={styles.p}>
        A execução das ordens depende de fatores externos, tais como:
      </p>
      <ul style={styles.ul}>
        <li style={styles.li}>Conexão entre bot, servidor e corretora.</li>
        <li style={styles.li}>Funcionamento da API da corretora.</li>
        <li style={styles.li}>Liquidez disponível no ativo.</li>
        <li style={styles.li}>Saldo disponível na conta do usuário.</li>
        <li style={styles.li}>Delay ou instabilidade no Telegram.</li>
        <li style={styles.li}>Restrições operacionais da corretora.</li>
      </ul>

      <p style={styles.p}>
        Por esse motivo, falhas operacionais externas não caracterizam defeito do
        serviço e não geram direito a reembolso, incluindo mas não se limitando a:
      </p>
      <ul style={styles.ul}>
        <li style={styles.li}>Falha de execução por desconexão da corretora.</li>
        <li style={styles.li}>Falha de execução por falta de liquidez.</li>
        <li style={styles.li}>Ordem rejeitada por saldo insuficiente.</li>
        <li style={styles.li}>Delay na entrega do sinal pelo Telegram.</li>
        <li style={styles.li}>
          Bloqueios, limites ou instabilidades na plataforma da corretora.
        </li>
        <li style={styles.li}>
          Erros de ordem provenientes do provedor de sinais.
        </li>
        <li style={styles.li}>
          Instabilidade na internet ou dispositivo do usuário.
        </li>
      </ul>

      <hr style={styles.divider} />

      <h1 style={styles.h1}>
        4. Regras de Reembolso Relacionadas à Execução de Ordens
      </h1>
      <p style={styles.p}>
        O usuário declara estar ciente de que variações de valor, falhas de
        execução e diferenças no volume operado podem ocorrer devido às limitações
        tecnológicas e operacionais das corretoras. Para garantir clareza e
        transparência, aplicam-se as seguintes regras:
      </p>

      <h3 style={styles.h3}>4.1 Situações em que NÃO há reembolso</h3>
      <p style={styles.p}>Não haverá reembolso em nenhuma das situações abaixo:</p>
      <ol style={styles.ul}>
        <li style={styles.li}>
          O bot deveria executar a ordem, a ordem teria sido win na corretora,
          mas ocorreu erro de execução.
        </li>
        <li style={styles.li}>
          O bot executou a ordem com valor monetário menor que o configurado e o
          resultado foi win.
        </li>
        <li style={styles.li}>
          O bot executou a ordem com valor monetário menor que o configurado e o
          resultado foi loss causado por bug no software.
        </li>
        <li style={styles.li}>
          O bot executou a ordem com valor monetário maior que o configurado e o
          resultado foi win.
        </li>
      </ol>

      <hr style={styles.divider} />

      <h1 style={styles.h1}>
        5. Única Situação com Direito a Reembolso Técnico
      </h1>
      <p style={styles.p}>
        Será elegível ao reembolso proporcional ou total somente quando ocorrer a
        seguinte situação:
      </p>

      <div style={styles.alertBox}>
        <strong>
          O bot executou a ordem com valor monetário maior que o configurado e o
          resultado foi loss.
        </strong>
      </div>

      <p style={styles.p}>Condições para análise:</p>
      <ul style={styles.ul}>
        <li style={styles.li}>
          A ordem deve ser comprovadamente superior ao valor configurado.
        </li>
        <li style={styles.li}>O bot deve ter registrado o envio do valor incorreto.</li>
        <li style={styles.li}>A corretora deve confirmar a execução no valor excedente.</li>
        <li style={styles.li}>
          O loss não pode ser decorrente de sinais errados, martingale externo ou
          manuseio incorreto do usuário.
        </li>
      </ul>

      <p style={styles.p}>O reembolso poderá ser:</p>
      <ul style={styles.ul}>
        <li style={styles.li}>
          Proporcional ao dano causado, no caso de perda isolada.
        </li>
        <li style={styles.li}>
          Total, caso seja comprovada falha sistemática ou recorrente do bot.
        </li>
      </ul>

      <hr style={styles.divider} />

      <h1 style={styles.h1}>6. Ausência de Garantia de Performance</h1>
      <p style={styles.p}>
        O bot é um sistema de automação e não garante lucro, taxa de
        assertividade, performance financeira ou resultados. Perdas decorrentes
        dos sinais recebidos, do comportamento do mercado ou das estratégias
        adotadas são de responsabilidade exclusiva do usuário.
      </p>

      <hr style={styles.divider} />

      <h1 style={styles.h1}>7. Propriedade Intelectual e Licença de Uso</h1>
      <p style={styles.p}>
        O Sonnybot concede ao usuário uma licença limitada, não exclusiva e intransferível
        para uso do software. É estritamente proibido: (i) Copiar, modificar ou criar
        obras derivadas do código-fonte; (ii) Realizar engenharia reversa, descompilação
        ou desmontagem do software; (iii) Vender, alugar, sublicenciar ou distribuir
        o software a terceiros. A violação destes termos resultará no cancelamento
        imediato da licença sem reembolso e possíveis medidas judiciais.
      </p>

      <hr style={styles.divider} />

      <h1 style={styles.h1}>8. Atualizações e Continuidade do Serviço</h1>
      <p style={styles.p}>
        O software poderá receber atualizações para correção de bugs ou melhorias.
        O usuário reconhece que mudanças nas APIs das corretoras ou do Telegram
        podem impactar temporariamente o funcionamento do bot. O Sonnybot se compromete
        a trabalhar nas correções necessárias, mas interrupções causadas por mudanças
        em plataformas de terceiros não geram direito a indenização ou
        reembolso fora do prazo legal.
      </p>

      <hr style={styles.divider} />

      <h1 style={styles.h1}>9. Bloqueios e Restrições pela Corretora</h1>
      <p style={styles.p}>
        O usuário reconhece que as corretoras de Opções Binárias possuem Termos de
        Serviço próprios e departamentos de risco autônomos. O uso de ferramentas
        de automação pode estar sujeito à análise da corretora.
      </p>
      
      <div style={styles.alertBox}>
        <strong>Isenção de Responsabilidade sobre Saldos:</strong><br />
        Caso a corretora bloqueie a conta do usuário, limite o acesso, congele 
        valores depositados e/ou lucros obtidos através das operações (sejam elas 
        manuais ou via Sonnybot), <strong>o usuário concorda em isentar integralmente 
        o Sonnybot de qualquer responsabilidade ou dever de indenização.</strong>
      </div>

      <p style={styles.p}>
        O Sonnybot é apenas a ferramenta de execução (interface de software) e não detém 
        posse, custódia ou gestão dos valores financeiros do usuário. Qualquer disputa 
        referente a bloqueios, saques negados ou retenção de valores deve ser tratada e 
        resolvida exclusivamente e diretamente entre o <strong>usuário e a corretora</strong>.
      </p>

      <hr style={styles.divider} />

      <h1 style={styles.h1}>10. Resolução de Disputas</h1>
      <p style={styles.p}>
        Para incentivar a celeridade e reduzir custos para ambas as partes, o usuário e 
        o Sonnybot concordam em buscar, primeiramente, a resolução de qualquer disputa, 
        reclamação ou controvérsia decorrente destes termos de forma informal e amigável.
      </p>
      <p style={styles.p}>
        O usuário se compromete a entrar em contato com o suporte oficial antes de iniciar 
        qualquer disputa judicial ou processo administrativo (PROCON, etc.), concedendo 
        um prazo razoável para análise e resposta da equipe técnica.
      </p>

      <hr style={styles.divider} />

      <h1 style={styles.h1}>11. Aceitação dos Termos</h1>
      <p style={styles.p}>Ao contratar o serviço, o usuário declara que:</p>
      <ul style={styles.ul}>
        <li style={styles.li}>Leu e compreendeu as regras acima.</li>
        <li style={styles.li}>
          Está ciente das limitações tecnológicas e dos riscos de bloqueio por parte das corretoras.
        </li>
        <li style={styles.li}>Concorda com a política de reembolso, execução e isenção de responsabilidade.</li>
      </ul>
    </div>
  );
}